export default __webpack_public_path__ + "static/media/fireflink-assets.3d29aacc.svg";